var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import { HomeRouter } from 'routes';
import { Map } from 'immutable';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import algoliasearch from 'algoliasearch';
import StreamComponent from './stream';
// import * as funcs from 'containers/Stream2/reducer'
// - Import API
// - Import actions
// - Import actions
import { imageGalleryActions, postActions, userActions, globalActions, circleActions, notifyActions } from 'src/store/actions';
import * as searchActions from 'store/actions/searchActions';
import './checkout.css';
var drawerWidth = 305;
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            width: '100%',
            marginTop: theme.spacing.unit * .2,
            zIndex: 1,
            overflow: 'hidden',
        },
        appFrame: {
            position: 'relative',
            display: 'flex',
            width: '100%',
            height: '100%',
        },
        navIconHide: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _a),
        drawerHeader: theme.mixins.toolbar,
        drawerPaper: (_b = {
                maxWidth: drawerWidth,
                width: drawerWidth
            },
            _b[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                position: 'absolute',
                height: '50%',
                overflow: 'hidden'
            },
            _b),
        drawerPaperLarge: (_c = {
                width: drawerWidth
            },
            _c[theme.breakpoints.up('md')] = {
                width: drawerWidth,
                height: '35%',
                overflow: 'hidden'
            },
            _c.top = 65,
            _c.backgroundColor = '#D5D5D5',
            _c.borderRight = 0,
            _c),
        menu: {
            height: '100%',
        },
        content: (_d = {
                // backgroundImage: `url(https://media.idownloadblog.com/wp-content/uploads/2016/01/bokeh-snow-flare-water-white-splash-pattern-9-wallpaper.jpg)`,   // background of post component 
                // backgroundImage: 'linear-gradient(217deg, rgba(255,0,0,.3), rgba(255,0,0,0.2) 70.71%)',
                // backgroundImage: 'linear-gradient(rgba(247,187,151,.8)20%,rgba(221,94,137,.5))',
                backgroundColor: '#fff',
                width: '100%',
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                flexGrow: 1,
                // padding: theme.spacing.unit * 1,
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                height: 'calc(100% - 56px)',
                marginTop: 56
            },
            _d[theme.breakpoints.up('sm')] = {
                height: 'calc(100% - 64px)',
                marginTop: 64,
            },
            _d),
        'content-left': {
            marginLeft: 0,
        },
        'content-right': {
            marginRight: 0,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        'contentShift-left': (_e = {
                marginLeft: 0
            },
            _e[theme.breakpoints.up('md')] = {
                marginLeft: 0 // controls how much content shifts when sidebar appears
            },
            _e),
        'contentShift-right': (_f = {
                marginRight: 0
            },
            _f[theme.breakpoints.up('md')] = {
                marginRight: 0 // controls how much content shifts when sidebar appears
            },
            _f)
    });
};
// - Create Home component class
var HomeComponent = /** @class */ (function (_super) {
    __extends(HomeComponent, _super);
    // Constructor
    function HomeComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.mount = React.createRef();
        /**
         * Handle drawer toggle
         */
        _this.handleDrawerToggle = function () {
            _this.setState({ drawerOpen: !_this.state.drawerOpen });
        };
        _this.search = _this.search.bind(_this);
        // Default state
        _this.state = {
            drawerOpen: true,
            AmountDue: 0,
            index: ''
        };
        return _this;
        // Binding function to `this`
    }
    HomeComponent.prototype.componentWillMount = function () {
        var _a = this.props, global = _a.global, clearData = _a.clearData, loadData = _a.loadData, authed = _a.authed, defaultDataEnable = _a.defaultDataEnable, isVerifide = _a.isVerifide, goTo = _a.goTo;
        // if (!authed) {
        //   goTo!('/login')
        //   return
        // }
        // if (!isVerifide) {
        //   goTo!('/emailVerification')
        // } else 
        if (!global.get('defaultLoadDataStatus')) {
            clearData();
            loadData();
            defaultDataEnable();
        }
    };
    HomeComponent.prototype.componentDidMount = function () {
        var ALGOLIA_APP_ID = 'K3EYIA5OK5';
        var ALGOLIA_API_SEARCHKEY = '41f1240a843ee12d460dcb47d8b3b1dd';
        // funcs.fetchPostsByType(this.props.Filter!, '')
        var client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_SEARCHKEY, { protocol: 'https:' });
        var index = client.initIndex("" + this.props.index);
        this.props.loadPosts(this.props.Filter);
        this.setState({ index: index });
        this.search(index);
    };
    HomeComponent.prototype.search = function (index) {
        var _this = this;
        index.search({
            query: this.props.Filter
        }).then(function (data) {
            // 
            _this.props.clearState();
            data.hits.forEach(function (hit) {
                var p;
                var id;
                p = hit;
                if (p) {
                    id = p.id;
                }
                // 
                // this.dbGetPostById(hit.ownerUserId!, hit.id!)
                _this.props.addPost(p.ownerUserId, p, _this.props.Filter);
            });
        });
    };
    /**
     * Render DOM component
     *
     * @returns DOM
     *
     * @memberof Home
     */
    HomeComponent.prototype.render = function () {
        var HR = HomeRouter;
        var St = StreamComponent;
        var _a = this.props, loaded = _a.loaded, authed = _a.authed, loadDataStream = _a.loadDataStream, mergedPosts = _a.mergedPosts, hasMorePosts = _a.hasMorePosts, showSendFeedback = _a.showSendFeedback, translate = _a.translate, classes = _a.classes, theme = _a.theme;
        var drawerOpen = this.state.drawerOpen;
        var anchor = theme.direction === 'rtl' ? 'right' : 'left';
        return (React.createElement("div", { className: classes.root },
            React.createElement("script", { async: true, src: 'https://static-na.payments-amazon.com/OffAmazonPayments/us/js/Widgets.js' }),
            React.createElement("div", { className: classes.appFrame }),
            React.createElement("div", { style: { fontWeight: 700, fontFamily: 'eurostile, sans-serif', fontSize: '30px', textAlign: 'center',
                    letterSpacing: '.05em', width: '100%', backgroundColor: 'white', marginRight: '5%' } },
                React.createElement(St, { posts: this.props.mergedPosts, loadStream: loadDataStream, hasMorePosts: hasMorePosts, displayWriting: false, currentItemId: this.props.CurrentItemId }),
                React.createElement("div", null))));
    };
    return HomeComponent;
}(Component));
export { HomeComponent };
// - Map dispatch to props
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        addPost: function (uid, post, filter) { return dispatch(searchActions.addFilter(uid, post, filter)); },
        clearState: function () { return dispatch(searchActions.clearState()); },
        loadPosts: function (type) { return dispatch(postActions.dbGetPostsByType(type, 0, 10)); },
        loadDataStream: function (page, limit) { return dispatch(postActions.dbGetPosts(page, limit)); },
        loadData: function () {
            dispatch(postActions.dbGetPosts());
            dispatch(imageGalleryActions.dbGetImageGallery());
            dispatch(userActions.dbGetUserInfo());
            dispatch(notifyActions.dbGetNotifications());
            dispatch(circleActions.dbGetCircles());
            dispatch(circleActions.dbGetUserTies());
            dispatch(circleActions.dbGetFollowers());
        },
        clearData: function () {
            dispatch(imageGalleryActions.clearAllData());
            dispatch(postActions.clearAllData());
            dispatch(userActions.clearAllData());
            dispatch(notifyActions.clearAllNotifications());
            dispatch(circleActions.clearAllCircles());
            dispatch(globalActions.clearTemp());
        },
        defaultDataDisable: function () {
            dispatch(globalActions.defaultDataDisable());
        },
        defaultDataEnable: function () {
            dispatch(globalActions.defaultDataEnable());
        },
        goTo: function (url) { return dispatch(push(url)); },
        showSendFeedback: function () { return dispatch(globalActions.showSendFeedback()); },
        hideSendFeedback: function () { return dispatch(globalActions.hideSendFeedback()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], {});
    var global = state.get('global', {});
    var userProfile = state.getIn(['user', 'info', uid], {});
    var mergedPosts = Map({});
    var Filter = ownProps.Filter;
    var circles = state.getIn(['circle', 'circleList'], {});
    var followingUsers = state.getIn(['OmniSearch', 'Mens'], {});
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    // const posts = state.getIn(['post', 'userPosts', uid ], {})
    var hasMorePosts = state.getIn(['post', 'stream', 'hasMoreData'], true);
    var AmountDue = 0;
    var FilterRes = state.getIn(['post', 'filteredPosts', "" + Filter], {});
    var filteredPosts = Map({});
    var posts = state.getIn(['post', 'filteredPosts']);
    var newPosts = state.getIn(['shoppingBag', 'PostArr', uid]);
    mergedPosts = mergedPosts.merge(newPosts);
    //    try {
    //     followingUsers.forEach((user, userId) => {
    //      let newPosts = state.getIn(['OmniSearch', 'Mens', userId], {})
    //      if (newPosts) {
    //       mergedPosts = mergedPosts.merge(newPosts)
    //      }
    //    })
    //  } catch (e) {
    //  }
    try {
        FilterRes.forEach(function (user, userId) {
            var newPosts = state.getIn(['post', 'filteredPosts', "" + Filter, userId], {});
            if (newPosts) {
                mergedPosts = mergedPosts.merge(newPosts);
            }
        });
    }
    catch (e) {
    }
    return {
        uid: state.getIn(['authorize', 'uid'], {}),
        authed: state.getIn(['authorize', 'authed'], false),
        isVerifide: state.getIn(['authorize', 'isVerifide'], false),
        translate: getTranslate(state.get('locale')),
        currentLanguage: getActiveLanguage(state.get('locale')).code,
        bag: state.getIn(['shoppingBag', 'PostArr']),
        // name: userProfile ? userProfile.fullName.split(' ', 1) : '',
        mergedPosts: mergedPosts,
        AmountDue: AmountDue,
        global: global,
        hasMorePosts: hasMorePosts,
        loaded: state.getIn(['user', 'loaded']) && state.getIn(['imageGallery', 'loaded']) && state.getIn(['notify', 'loaded']) && state.getIn(['circle', 'loaded']),
        Camera: Camera,
        Scene: Scene,
        Filter: ownProps.Filter
        // AmountDue : price || 0
    };
};
// - Connect component to redux store
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(HomeComponent)));



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPgStream/FrontPgSlider.tsx
// module id = 1492
// module chunks = 0 1 2 3